import amazonAlexa from './icons/apps/amazon-alexa.svg';
import googleAssistant from './icons/apps/google-assistant.svg';
import siriShortcuts from './icons/apps/siri-shortcuts.png';
import homeyBridgeHome from './icons/homey/homey-bridge-home.svg';
import homeyCloud from './icons/homey/homey-cloud.svg';
import homeyPro2023Fill from './icons/homey/homey-pro-2023-fill.svg';
import homeyProMini from './icons/homey/homey-pro-mini.svg';
import homeyPro from './icons/homey/homey-pro.svg';
import homeySHS from './icons/homey/homey-shs.svg';

export const icon = {
  apps: {
    amazonAlexa,
    googleAssistant,
    siriShortcuts,
  },
  homey: {
    bridgeHome: homeyBridgeHome,
    cloud: homeyCloud,
    pro: homeyPro,
    pro2023Fill: homeyPro2023Fill,
    proMini: homeyProMini,
    shs: homeySHS,
  },
} as const;

export type IconType = typeof icon;
